import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class usersProfile_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
            
            
            <div class="user-profil">
            
               <div class="user-header">
                   <button data-bind="visible: hasWriteAccess, event: { click: onClickEdit }" class="btn icon-only icon i-edit" type="button"><span class="hidden-text">Edit</span></button>
                   <a href="/users/" class="btn icon-only icon i-back" type="button"></a>

                   <div class="w-user-img"><img class="user-img" data-bind="attr:{src: pictureUrl}" alt=""></div>
                   <strong>
                        <span data-bind="text: firstName"></span>
                        <span data-bind="text: lastName"></span>
                   </strong>
                   

               </div>
              
               <div class="user-infos">
               
                   <ul class="brand-list" data-bind="foreach: userBrands">
                       <li class="brand-item " data-bind="css: iconImage"></li>
                   </ul>
                   
                   <ul class="user-infos-list">
                       <li class="user-infos-item">
                           <span class="user-infos-title">First Name</span>
                           <span data-bind="text: firstName" class="user-infos-value"></span>
                       </li>
                       
                       <li class="user-infos-item">
                           <span class="user-infos-title">Last Name</span>
                           <span data-bind="text: lastName" class="user-infos-value"></span>
                       </li>
                       
                       <li class="user-infos-item">
                           <span class="user-infos-title">User Name</span>
                           <span data-bind="text: loginName" class="user-infos-value"></span>
                       </li>
                       
                       <li class="user-infos-item">
                           <span class="user-infos-title">Email</span>
                           <span data-bind="text: email" class="user-infos-value"></span>
                       </li>
                       
                        <li class="user-infos-item">
                           <span class="user-infos-title">Role(s)</span>
                           <span data-bind="text: roles" class="user-infos-value"></span>
                       </li>
                   </ul>
               </div>
           </div>
              <!--     
             <div class="w-form-body">
                <div class="form-body">
    
                    
             
                    
                 
                     
                    
      
                    
                    
                </div>
                <div class="form-body">
                    <strong class="form-sub-title">personal info</strong>
                    <div class="form-group">
                        <legend class="form-legend">Roles</legend>
                        <ul data-bind="foreach: roles">
                            <li data-bind="text: $data"></li>
                        </ul>
                        
                    </div>
                    
                    <div class="form-group">
                        <legend class="form-legend">Projects</legend>
                        <ul data-bind="foreach: brands">
                            <li class="brand-item " data-bind="css: iconImage"></li>
                        </ul>
                    </div>
                    
                    <div class="w-img"><img data-bind="attr:{src: pictureUrl}" alt=""></div>

                </div>
               
            </div>
            `;
    }

    protected getTemplateName(): string{
        return "usersProfile-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    protected buildViewModel(): any{
        let huit_neuf_this = this;

        return {
            idUser: ko.observable("")
            ,firstName: ko.observable("")
            ,lastName: ko.observable("")
            ,loginName: ko.observable("")
            ,hasWriteAccess: ko.observable(false)
            ,email: ko.observable("")
            ,pictureUrl: ko.observable(null)
            ,roles: ko.observableArray([])
            ,userBrands: ko.observableArray([])
            ,isActive: ko.observable("")
            ,onClickEdit : function(data, event){ huit_neuf_this.onClickEdit(data.idUser())}
        }
    }

    public setHasWriteAccess(hasWriteAccess: boolean): void{this.getTemplateViewModel().hasWriteAccess(hasWriteAccess);}


    public setRoles(selectedRoles : Array<{name: string}>){
        let roles = [];
        for(let r of selectedRoles){
            roles.push(r.name);
        }
        this.getTemplateViewModel().roles(roles);
    }
/*
    public setBrands(selectedBrands : Array<{name: string}>){
        let brands = [];
        for(let r of selectedBrands){
            brands.push(r.name);
        }
        this.getTemplateViewModel().brands(brands);
    }
*/
    public setBrands(brands: any){
        this.getTemplateViewModel().userBrands(brands);
    }

    public onClickEdit(idUser){
        this.caller.editUser(idUser);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfile_template.ts